import { getResults } from '.'
import { POST } from '../util/fetch-methods'

export type LoginParams = {
    email: string
    password: string
}

export const login = (loginParams: LoginParams) => {
    return getResults(`/api/v1/users/login/`, POST(loginParams, true))
}
